import { render, staticRenderFns } from "./SyncBlock.vue?vue&type=template&id=3f5dccea&scoped=true&"
import script from "./SyncBlock.vue?vue&type=script&lang=js&"
export * from "./SyncBlock.vue?vue&type=script&lang=js&"
import style0 from "./SyncBlock.vue?vue&type=style&index=0&id=3f5dccea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5dccea",
  null
  
)

export default component.exports